import M from "moment";
import * as R from "ramda";
import React, { Component } from "react";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import { mapToObjectDDL } from "../../../common/mapper";
import { ACTIVITY_TYPE } from "../../../common/Constants";
import { getSupplier, getSupplierExpOptions } from "../utilUpdate";

class ReceivingPartNOSInputs extends Component {
  constructor(props) {
    super(props);
  }

  handleInputDateChange = (name, value) => {
    const formattedDate = M(value).format("DD-MM-YYYY");
    this.props.setValue(name, formattedDate);
  };

  render() {
    return (
      <>
        <div className="grid grid-3x grid-mobile-none gap-15px">
          <div id="grid-1">
            <SimpleInput
              id="input_text_nosl"
              name="shippingNo"
              label="No. ShippngList (SL)"
              box="onlyNumber"
              mandatory
              errorMessage={this.props.errors.shippingNo}
              readOnly={this.props.mode == "view"}
              value={this.props.controls?.shippingNo?.value}
              onChange={({ target }) =>
                this.props.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_text_nosl"
              name="numberOfSPBP"
              label="No. SPBP"
              mandatory
              errorMessage={this.props.errors.numberOfSPBP}
              readOnly
              value={this.props.controls?.numberOfSPBP?.value}
              onChange={({ target }) =>
                this.props.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_text_noinvoice"
              name="invoiceNo"
              box="onlyNumber"
              label="No. Invoice"
              readOnly={this.props.mode == "view"}
              value={this.props.controls?.invoiceNo?.value}
              onChange={({ target }) =>
                this.props.setValue(target.name, target.value)
              }
            />
          </div>
          <div id="grid-2">
            <SimpleInput
              id="input_text_no_penerimaan"
              name="receivedNo"
              box="onlyNumber"
              label="No. Penerimaan"
              readOnly={this.props.mode == "view"}
              value={this.props.controls?.receivedNo?.value}
              onChange={({ target }) =>
                this.props.setValue(target.name, target.value)
              }
            />
            <SimpleDate
              id="select_date_tglspbm"
              name="dateOfSPBP"
              label="Tgl. SPBP"
              mandatory
              nextdate
              maxDate={M(new Date()).format("DD-MM-YYYY")}
              errorMessage={this.props.errors.dateOfSPBP}
              disabled={this.props.mode != "edit"}
              date={this.props.controls?.dateOfSPBP.value}
              onChange={(value) =>
                this.handleInputDateChange("dateOfSPBP", value)
              }
            />

            <SimpleDate
              id="select_date_tglsl"
              name="shippingDate"
              label="Tanggal SL"
              mandatory
              nextdate
              maxDate={M(new Date()).format("DD-MM-YYYY")}
              errorMessage={this.props.errors.shippingDate}
              disabled={this.props.mode == "view"}
              date={this.props.controls?.shippingDate?.value}
              onChange={(value) =>
                this.handleInputDateChange("shippingDate", value)
              }
            />
          </div>
          <div id="grid-3">
            <SimpleDDL
              id="select_options_nama_supp"
              name="supplierId"
              label="Nama Supplier"
              box="search"
              mandatory
              errorMessage={this.props.errors.supplierId}
              readOnly={this.props.mode === "view"}
              isClearable={true}
              options={
                this.props.dataSupplier?.length > 0
                  ? getSupplier(this.props.dataSupplier)
                  : []
              }
              value={
                this.props.controls &&
                Object.keys(this.props.controls).length > 0
                  ? mapToObjectDDL(
                      this.props.controls.supplierId?.value?.name,
                      this.props.controls.supplierId?.value?.value
                    )
                  : null
              }
              onChange={(value, { name }) => this.props.setValue(name, value)}
              // options={
              //   this.props.dataSupplier?.length
              //     ? this.props.dataSupplier.map((item) =>
              //         mapToObjectDDL(item.supplierName, item.supplierId)
              //       )
              //     : []
              // }
              // value={this.props.controls?.supplierId?.value} // harus object { label, value }
              // onChange={(selected, { name }) => {
              //   this.props.setValue(name, selected || null); // simpan object, bukan string
              // }}
            />

            <SimpleInput
              id="input_text_no_pol_truk"
              name="carId"
              label="Nopol Mobil"
              box="alphaNumericStrict"
              readOnly={this.props.mode == "view"}
              value={this.props.controls?.carId?.value}
              onChange={({ target }) =>
                this.props.setValue(target.name, target.value)
              }
            />
            <SimpleDDL
              id="select_options_ekpedisi"
              name="expeditionId"
              box="search"
              label="Nama Ekspedisi"
              readOnly={this.props.mode == "view"}
              isClearable={true}
              options={
                this.props.dataSupplierExpedition?.length > 0
                  ? getSupplierExpOptions(this.props.dataSupplierExpedition)
                  : []
              }
              value={
                this.props.controls &&
                Object.keys(this.props.controls).length > 0
                  ? mapToObjectDDL(
                      this.props.controls.expeditionId?.value?.value,
                      this.props.controls.expeditionId?.value?.value
                    )
                  : null
              }
              onChange={(value, { name }) => this.props.setValue(name, value)}
            />
          </div>
        </div>
        <div
          style={{
            display: "grid",
            gap: "15px",
            gridTemplateColumns: "1fr 1fr",
          }}
        >
          <SimpleTextArea
            typeInputCase="normal"
            name="note"
            label="Deskripsi"
            readOnly={this.props.mode == "view"}
            value={this.props.controls?.note?.value}
            onChange={({ target }) =>
              this.props.setValue(target.name, target.value)
            }
          />
          <p style={{ justifySelf: "end" }}>
            {this.props.controls?.expeditionId?.value?.name}
          </p>
        </div>
      </>
    );
  }
}

export default ReceivingPartNOSInputs;
